import { ArrowUpRight } from "lucide-react";
import { WhatsAppIcon } from "@/components/Logo";
import { EMAIL, PHONE_DISPLAY, PHONE_TEL, WHATSAPP_LINK } from "@/site";
import { useLang } from "@/i18n";

const Footer = () => {
  const { t } = useLang();
  const links = [
    { href: "/#process", label: t.nav.process },
    { href: "/#work", label: t.nav.work },
    { href: "/about", label: t.nav.about },
    { href: "/faq", label: "FAQ" },
    { href: "/contact", label: t.nav.contact },
  ];

  return (
    <footer data-testid="site-footer" className="bg-ink text-bone">
      <div className="mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-28">
        <div className="flex flex-col justify-between gap-12 md:flex-row md:items-end">
          <div>
            <div className="flex items-center gap-5">
              <img
                src="/images/logo.png"
                alt="HHB Group — fashion clothing"
                className="h-16 w-auto rounded-sm bg-bone px-4 py-2"
              />
              <span className="font-serif text-2xl font-semibold tracking-tight">
                HHB <span className="italic text-clay">Clothing Co</span>
              </span>
            </div>
            <p className="mt-8 max-w-md font-serif text-3xl leading-snug tracking-tight sm:text-4xl">
              {t.footer.tag1} <em className="italic text-clay">{t.footer.tag2}</em>
            </p>
          </div>
          <a
            href="#quote"
            data-testid="footer-quote-button"
            className="group inline-flex w-fit items-center gap-2 rounded-full bg-bone px-8 py-4 text-xs font-semibold uppercase tracking-[0.14em] text-ink transition-colors duration-300 hover:bg-clay hover:text-bone"
          >
            {t.footer.cta}
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 rtl:rotate-[-90deg]" />
          </a>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-10 border-t border-bone/10 pt-10 text-sm text-bone/60 sm:grid-cols-3">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-bone/40">{t.footer.contactL}</p>
            <p className="mt-3" data-testid="footer-email">{EMAIL}</p>
            <p className="mt-1" data-testid="footer-phone">
              <a href={PHONE_TEL} className="transition-colors duration-300 hover:text-bone">{PHONE_DISPLAY}</a>
            </p>
            <p className="mt-3 max-w-[240px] text-xs leading-relaxed text-bone/40" data-testid="footer-address">{t.contact.addressV}</p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-bone/40">{t.footer.exploreL}</p>
            <div className="mt-3 flex flex-col gap-2">
              {links.map((l) => (
                <a key={l.href} href={l.href} data-testid={`footer-link-${l.href.slice(1)}`} className="transition-colors duration-300 hover:text-bone">
                  {l.label}
                </a>
              ))}
            </div>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-bone/40">{t.footer.chatL}</p>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="mt-3 inline-flex items-center gap-2 transition-colors duration-300 hover:text-bone"
            >
              <WhatsAppIcon className="h-4 w-4" />
              {t.footer.waText}
            </a>
          </div>
        </div>

        <p className="mt-14 text-xs uppercase tracking-[0.2em] text-bone/30">{t.footer.rights}</p>
      </div>
    </footer>
  );
};

export default Footer;
